function clearTimeouts()
{
  console.info('clear timeouts');
  clearTimeout(eventTimeOut);
  clearTimeout(eventTimeOutResponse);
  clearTimeout(eventTimeOutFeedback);
  clearTimeout(timerDisplay);
  clearTimeout(timerCFPTDisplay);
  if(!shouldWaitResponseWindow()){
    clearResponseWindowTimeouts();
    clearAllPostpones();
  }
  clearDisplayScreenTimeouts();
}